import { LineUpPlayerCardProps } from '@stadionhq-v3/football-ui';

type Position =
  | 'defender'
  | 'midfielder'
  | 'forward'
  | 'goalkeeper'
  | 'striker'
  | 'substitute';

export const orderByPosition = <T extends LineUpPlayerCardProps>(
  profiles: T[]
): Array<T> => {
  const positionRank: { [key in Position]: number } = {
    goalkeeper: 1,
    defender: 2,
    midfielder: 3,
    forward: 4,
    striker: 5,
    substitute: 6,
  };

  return profiles?.sort(
    (a: LineUpPlayerCardProps, b: LineUpPlayerCardProps) => {
      const positionOrderA =
        positionRank[(a.position?.toLowerCase() as Position) || 'substitute'];
      const positionOrderB =
        positionRank[(b.position?.toLowerCase() as Position) || 'substitute'];

      if (positionOrderA !== positionOrderB) {
        return positionOrderA - positionOrderB;
      }

      // If positions are the same, sort by shirt number
      return (a.shirtNumber || 0) - (b.shirtNumber || 0);
    }
  );
};
